import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getPermissionsCatalog = () => {
  return axiosPrivate.get(`/dashboard/v1/roles/permissions_catalog`);
};